
import React from "react";
import { useNavigate } from "react-router-dom";

const VendorVerified = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
      <svg
        className="w-24 h-24 text-green-600 mb-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" strokeWidth="2" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12l2 2l4-4"
        />
      </svg>
      <h1 className="text-2xl font-semibold text-[#2A668D] mb-2">
        Email Verified Successfully!
      </h1>
      <p className="text-gray-600 max-w-md">
        Your account has been verified. Please wait while the admin reviews and approves your registration.
        You will be notified once your account is activated.
      </p>

      <button
        onClick={() => navigate("/")}
        className="mt-6 bg-[#2A668D] text-white py-2 px-6 rounded-md"
      >
        Return to Login
      </button>
    </div>
  );
};

export default VendorVerified;
